import type { OpenCallStage } from '@repo/api/open-calls/graphql';
import request from 'graphql-request';

import { oktaAuth } from '@/auth';
import {
  mutationCreateStage,
  mutationRenameStage,
  stagesQuery,
} from '@/services/stages/queries.graphql';
import { QueryStateManagement } from '@/state';
import { ConfigService } from '../config';
import * as constants from '../constants';

type StagesRequest = {
  stages: OpenCallStage[];
};

export class StagesService {
  static async queryByOpenCallId(openCallId: string) {
    try {
      const storedToken = sessionStorage.getItem(constants.TOKEN_STORAGE_KEY);
      const token = storedToken ?? (await oktaAuth.getAccessToken());

      const result = await QueryStateManagement.client.fetchQuery({
        queryKey: ['stages', openCallId],
        queryFn: () =>
          request<StagesRequest>(
            `${ConfigService.BACKEND_GRAPHQL_ENDPOINT}${window.location.search}`, //TODO: remove the window.location.search
            stagesQuery,
            { openCallId },
            {
              Authorization: `Bearer ${token}`,
            },
          ),
        gcTime: constants.QUERY_CACHE_TIME,
      });
      return result.stages;
    } catch (error) {
      console.error('Error fetching stages', error);
      throw error;
    }
  }
  static async createStage(openCallId: string) {
    try {
      const storedToken = sessionStorage.getItem(constants.TOKEN_STORAGE_KEY);
      const token = storedToken ?? (await oktaAuth.getAccessToken());

      const result = await QueryStateManagement.client.fetchQuery({
        queryKey: ['createStage', openCallId],
        queryFn: () =>
          request<{ createStage: OpenCallStage }>(
            `${ConfigService.BACKEND_GRAPHQL_ENDPOINT}`,
            mutationCreateStage,
            { openCallId },
            {
              Authorization: `Bearer ${token}`,
            },
          ),
        gcTime: constants.QUERY_CACHE_TIME,
      });
      return result.createStage;
    } catch (error) {
      console.error('Error creating stage', error);
      throw error;
    }
  }
  static async renameStage(
    openCallId: string,
    stageId: string,
    newName: string,
  ) {
    try {
      const storedToken = sessionStorage.getItem(constants.TOKEN_STORAGE_KEY);
      const token = storedToken ?? (await oktaAuth.getAccessToken());

      const result = await QueryStateManagement.client.fetchQuery({
        queryKey: ['renameStage', openCallId, stageId, newName],
        queryFn: () =>
          request<{ renameStage: OpenCallStage }>(
            `${ConfigService.BACKEND_GRAPHQL_ENDPOINT}`,
            mutationRenameStage,
            { openCallId, stageId, newName },
            {
              Authorization: `Bearer ${token}`,
            },
          ),
        gcTime: constants.QUERY_CACHE_TIME,
      });
      return result.renameStage;
    } catch (error) {
      console.error('Error renaming stage', error);
      throw error;
    }
  }
}
